{
  "aiGeneratedAnswer": "AI generált válasz",
  "allCategories": "Összes kategória",
  "appliedFiltersToCurrentSearch": "Alkalmazott szűrők az aktuális keresésre",
  "apply": "Alkalmaz",
  "applyFilters": "Szűrők alkalmazása",
  "autocompleteOptionsFound_one": "{{count}}{{label}} automatikus kiegészítési opció található.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} automatikus kiegészítési opció található.",
  "autocompleteSuggestion": "automatikus kiegészítési javaslat: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} automatikus javaslat található.",
  "autocompleteSuggestionsFound_other": "{{count}} automatikus javaslat található.",
  "basedOnYourDevice": " (a készülék alapján)",
  "basedOnYourInternetAddress": " (az internetes cím alapján)",
  "categoriesText_one": "Az alábbi kategória adott találatot erre: - <strong>{{query}}</strong>",
  "categoriesText_other": "Az alábbi kategóriák adtak találatot erre: - <strong>{{query}}</strong>",
  "clearAll": "Tisztítsa meg az összeset",
  "clearMinAndMax": "Töröld a minimumot és maximumot",
  "clearTheRangeToSelectOptions": "Törölje az Opciók kiválasztásához a tartományt.",
  "clearTheSearchBar": "Törölje a keresősávot",
  "conductASearch": "Kutatást végez",
  "currentLocation": "Jelenlegi helyzet",
  "didYouMean": "Ezt szerette volna: <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Ha automatikus kiegészítési eredmények érhetők el, használd a fel/le nyilakat a böngészéshez, és az Entert a kiválasztáshoz.",
  "feedback": "Visszacsatolás",
  "filterGroupSearchInputLabel": "Keresés a(z) {{title}} lehetőségei között",
  "invalidRange": "Érvénytelen hatótávolság",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Keresse meg a következő eredményoldalt",
  "navigateToThePreviousResultsPage": "Keresse meg az előző eredményoldalt",
  "noAutocompleteOptionsFound": "0 automatikus kiegészítési lehetőség található.",
  "noAutocompleteSuggestionsFound": "0 automatikus kiegészítési javaslat található.",
  "noResultsFoundIn": "Nem találhatók találatok a(z) {{currentVerticalLabel}}-ben.",
  "paginationPage": "{{pageNumber}}. oldal",
  "pagination": "Lapozás",
  "readMoreAbout": "Olvass többet erről: <a>{{name}}</a>",
  "recentSearch": "legutóbbi keresés: {{query}}",
  "recentSearchesFound_one": "{{count}} legutóbbi keresés található.",
  "recentSearchesFound_other": "{{count}} legutóbbi keresés található.",
  "removeFilter": "„{{displayName}}“ szűrő eltávolítása",
  "resultPreview": "találati előnézete: {{value}}",
  "resultPreviewsFound_one": "{{count}} találati előnézet található.",
  "resultPreviewsFound_other": "{{count}} találati előnézet található.",
  "resultsCountText_one": "{{count}} találat",
  "resultsCountText_other": "{{count}} találat",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} / összesen {{resultsCount}} találat",
  "searchHere": "Keressen itt…",
  "showingAllInstead": "Helyette az összes {{currentVerticalLabel}} megjelenítése.",
  "showLess": "Kevesebb mutatása",
  "showMore": "Több mutatása",
  "sources_one": "Forrás ({{count}})",
  "sources_other": "Források ({{count}})",
  "submitSearch": "Küldje el a keresést",
  "suggestionResultsCount_one": "{{label}} - {{count}} találat",
  "suggestionResultsCount_other": "{{label}} - {{count}} találat",
  "thankYouForYourFeedback": "Köszönjük a visszajelzését!",
  "thisAnsweredMyQuestion": "Ez megválaszolta a kérdésemet",
  "thisDidNotAnswerMyQuestion": "Ez nem válaszolta meg a kérdésemet",
  "unselectAnOptionToEnterInARange": "Töröljön egy jelölést a tartomány megadásához.",
  "updateYourLocation": "Frissítse a tartózkodási helyét",
  "useCurrentLocation": "Használd a jelenlegi helyzetet",
  "useMyLocation": "Használd a helyzetemet",
  "viewAll": "Tekintse meg az összeset",
  "viewDetails": "A részletek megtekintése"
}
